export default "Boardgame Breakout is a part of the small board game cafe Nerd Cave.";